module.exports = __webpack_public_path__ + "static/media/image8.2560b7ff.jpeg";